import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { INeighborhoodDetails } from '@api'
import { NeighborhoodDetailsFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface Payload {
  updateNeighborhood: { neighborhood: INeighborhoodDetails }
}

const mutation = gql`
  mutation UpdateNeighborhoodMutation($input: UpdateNeighborhoodInput!) {
    updateNeighborhood(input: $input) {
      neighborhood {
        ...NeighborhoodDetailsFragment
      }
    }
  }
  ${NeighborhoodDetailsFragment}
`

const mutateHandler = handleFetchResult<Payload, INeighborhoodDetails>({
  handler: (data) => data.updateNeighborhood.neighborhood,
  name: 'Neighborhood Details',
})

export default function updateNeighborhood({
  id,
  maxEmployees,
  departments,
  name,
  color,
  spaces,
  removeSpaces,
  removeEmployees,
  employees,
}: {
  id: string
  maxEmployees?: number
  departments?: { id: string }[]
  spaces?: { id: string }[]
  removeSpaces?: { id: string }[]
  employees?: { id: string }[]
  removeEmployees?: { id: string }[]
  name?: string
  color?: string
}): Promise<INeighborhoodDetails> {
  const input = {
    data: {
      ...(maxEmployees ? { maxEmployees } : {}),
      ...(departments
        ? {
            departments: {
              connect: departments,
            },
          }
        : {}),
      ...(name ? { name } : {}),
      ...(color ? { color } : {}),
      ...(spaces
        ? {
            spaces: {
              connect: spaces,
            },
          }
        : {}),
      ...(employees
        ? {
            employees: {
              connect: employees,
            },
          }
        : {}),
      ...(removeSpaces
        ? {
            spaces: {
              disconnect: removeSpaces,
            },
          }
        : {}),
      ...(removeEmployees
        ? {
            employees: {
              disconnect: removeEmployees,
            },
          }
        : {}),
    },
    where: {
      id,
    },
  }

  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}
